module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2ruGC"))).then(() => parcelRequire('azMDt'));